import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

/** Authorization Code + PKCE (S256) auprès de Keycloak, servi sous /auth par la même origine. */
export const userManager = new UserManager({
  authority: `${window.location.origin}/auth/realms/crm`,
  client_id: 'crm-web',
  redirect_uri: `${window.location.origin}/callback`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: 'code',
  scope: 'openid profile email',
  automaticSilentRenew: true,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  ui_locales: 'fr',
});

export type KeycloakAction = 'UPDATE_PASSWORD' | 'CONFIGURE_TOTP';

/** Ouvre une action Keycloak (changement de mot de passe, double authentification) puis revient ici. */
export function runKeycloakAction(action: KeycloakAction, returnTo = window.location.pathname): Promise<void> {
  return userManager.signinRedirect({ state: { returnTo }, extraQueryParams: { kc_action: action } });
}
